import ConfigurationFileContents, {
  type PortalThemeVariables,
} from "@/interfaces/Configuration/ConfigurationFileContents";

type RuntimeConfigurationJson = {
  API_KEY?: string;
  API_BASE_URL?: string;
  CUSTOMER_PORTAL_KEY?: string;
  CONTENT_MANAGEMENT_SYSTEM_BASE_URL?: string;
  PORTAL_THEME_VARIABLES?: PortalThemeVariables;
};

async function loadRuntimeConfigurationFile() {
  const runtimeConfigUrl = new URL(
    `${import.meta.env.BASE_URL}config.json`,
    window.location.origin
  );

  try {
    const response = await fetch(runtimeConfigUrl, { cache: "no-store" });

    if (!response.ok) {
      return undefined;
    }

    return (await response.json()) as RuntimeConfigurationJson;
  } catch {
    return undefined;
  }
}

export async function getRuntimeConfiguration(): Promise<ConfigurationFileContents> {
  const runtimeConfigurationFile = await loadRuntimeConfigurationFile();

  return {
    publicApiKey:
      runtimeConfigurationFile?.API_KEY ??
      import.meta.env.VITE_PUBLIC_API_KEY ??
      "",
    publicApiBaseUrl:
      runtimeConfigurationFile?.API_BASE_URL ??
      import.meta.env.VITE_PUBLIC_API_BASE_URL ??
      "",
    customerPortalKey:
      runtimeConfigurationFile?.CUSTOMER_PORTAL_KEY ??
      import.meta.env.VITE_CUSTOMER_PORTAL_KEY ??
      "",
    contentManagementSystemBaseUrl:
      runtimeConfigurationFile?.CONTENT_MANAGEMENT_SYSTEM_BASE_URL ??
      import.meta.env.VITE_CONTENT_MANAGEMENT_SYSTEM_BASE_URL ??
      "",
    portalThemeVariables: runtimeConfigurationFile?.PORTAL_THEME_VARIABLES ?? {},
    runtimeSource: runtimeConfigurationFile ? "public-config" : "env-fallback",
  };
}
